import { ProductGroupItemResponse } from '@/types/service-response'

export class ProductGroup {
  public constructor (
    readonly id: number,
    readonly code: string,
    readonly bezeichnung: string,
    readonly text: string,
  ) {}

  static createFromResponse (responseData: ProductGroupItemResponse[]): Array<ProductGroup> {
    let result: Array<ProductGroup> = []
    if (responseData) {
      result = responseData.map((item: ProductGroupItemResponse ) => {
        return new ProductGroup(
          item.ID,
          item.Code ? item.Code : '',
          item.Bezeichnung ? item.Bezeichnung : '',
          `${item.Bezeichnung ? item.Bezeichnung : ''} (${item.Code ? item.Code : ''})`,
        )
      })
    }
    return result
  }
}
